import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
const KEY = "ag_association";

export const getAssociationId = () => localStorage.getItem(KEY);
export const setAssociationId = (id) => (id ? localStorage.setItem(KEY, id) : localStorage.removeItem(KEY));

api.interceptors.request.use((cfg) => {
  const aid = getAssociationId();
  if (aid) cfg.headers["X-Association-Id"] = aid;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("ag:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message ? "Si è verificato un errore. Riprova." : "Errore sconosciuto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function download(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
